const config = {
    API_URL: "http://18.188.184.213:8023/",
    AUTH_BACKEND: 'Dummy'
}

export default config
